// test1262
(1262 && 0);
